import { useState, useEffect } from "react";
import { FaLinkedin, FaInstagram, FaFacebook, FaGithub } from "react-icons/fa";
import { MdOutlineEmail } from "react-icons/md";
import { IoLocationOutline } from "react-icons/io5";
import { IoChevronDown, IoChevronUp } from "react-icons/io5";
import hd_image from "../components/images/hd_image.jpg";

export default function Sidebar() {
  const [openImage, setOpenImage] = useState(false);



  const [open, setOpen] = useState(window.innerWidth >= 768); // desktop default open

  // Prevent background scroll when image modal is open
useEffect(() => {
  if (openImage) {
    document.body.classList.add("modal-open");
  } else {
    document.body.classList.remove("modal-open");
  }
}, [openImage]);


  // Update open state whenever screen resizes (smooth responsive behavior)
  useEffect(() => {
    const handleResize = () => {
      if (window.innerWidth < 768) {
        setOpen(false); // mobile → collapse
      } else {
        setOpen(true); // desktop → always open
      }
    };

    window.addEventListener("resize", handleResize);
    return () => window.removeEventListener("resize", handleResize);
  }, []);

  return (
    <div className="flex flex-col items-center    md:p-6 text-white w-full">

{openImage && (
  <div
    className="fixed inset-0 bg-black/80 backdrop-blur-md flex justify-center items-center z-[99999999]"
    onClick={() => setOpenImage(false)}
  >
    <img
      src={hd_image}
      alt="Full"
      className="max-w-[90%] max-h-[90%] rounded-2xl shadow-xl 
                 scale-0 animate-zoomIn"
      // onClick={(e) => e.stopPropagation()}  
    />
  </div>
)}


      {/* Profile Card */}
      {/* <div className="w-full rounded-2xl p-1 relative"> */}
      <div className="w-full rounded-2xl px-2 md:px-2 pt-2 pb-2 relative">
        {/* Arrow Button (mobile only) */}
        <button
          onClick={() => setOpen(!open)}
          className="
      absolute top-0 right-0 
       p-1 
       rounded-tr-2xl rounded-bl-2xl 
        border-t border-l           
    border-cyan-500




      hover:bg-black/60 transition
      md:hidden
    "
        >
          {open ? (
            <IoChevronUp className="text-xl text-cyan-400" />
          ) : (
            <IoChevronDown className="text-xl text-cyan-400" />
          )}
        </button>

        {/* MOBILE LAYOUT → image left, text right */}
        <div className="flex md:flex-col items-center md:items-center gap-3">
          {/* IMAGE */}
          <div className="w-[160px] h-[110px] md:w-[200px] md:h-[200px] rounded-2xl overflow-hidden"
          onClick={() => setOpenImage(true)}
          >
            <img
              src={hd_image}
              alt="Profile"
              className="w-full h-full object-cover  rounded-2xl scale-[2.5] object-[50%_15%] cursor-pointer hover:scale-[2.6] transition-transform"
            />
          </div>

          {/* NAME + ROLE (right side on mobile, center on desktop) */}
          <div className="flex flex-col md:items-center justify-center w-full">
            <h2 className="text-xl md:text-2xl font-semibold text-left md:text-center">
              𝐇α𝗋ᑯ𝗂𝗸 𝐕𝗂𝗌ɦωα𝗸α𝗋ꭑα
            </h2>

            <p className="bg-[#343333] px-2 py-1 rounded-lg text-sm md:text-lg mt-3 text-left md:text-center inline-block w-fit">
              Software Developer
            </p>
          </div>
        </div>
      </div>

      {/* EXPANDABLE SECTION */}
      <div
        className={`
          overflow-hidden  transition-all duration-500 ease-in-out w-full
          ${open ? "max-h-[800px] opacity-100 mt-2 mb-1 md:mt-4" : "max-h-0 opacity-0"}
        `}
      >
        {/* Email */}
        <div className="w-full flex flex-col items-center space-y-4 md:space-y-8 px-4 md:mt-6">
          <a
            href="mailto:hello@hardik.me"
            className="flex flex-row gap-4 items-center w-full max-w-xs transform transition-transform hover:scale-105"
          >
            <div className="h-[40px] w-[40px] md:h-[50px]  md:w-[50px] border border-gray-600 flex items-center justify-center rounded-xl">
              <MdOutlineEmail className="h-[20px] w-[20px] text-[#00b5fc]" />
            </div>
            <div className="flex flex-col">
              <p className="text-gray-400 text-xs md:text-sm uppercase">Email</p>
              <p className="break-words text-base md:text-lg">hello@hardik.me</p>
            </div>
          </a>

          {/* Location */}
          <a
            href="https://www.google.com/maps/search/Bhopal,+IN"
            target="_blank"
            rel="noopener noreferrer"
            className="flex flex-row gap-4 items-center w-full max-w-xs transform transition-transform hover:scale-105"
          >
            <div className="h-[40px] w-[40px] md:h-[50px]  md:w-[50px]  border border-gray-600 flex items-center justify-center rounded-xl">
              <IoLocationOutline className="h-[25px] w-[25px] text-[#00b7ff]" />
            </div>
            <div className="flex flex-col">
              <p className="text-gray-400 text-xs md:text-sm uppercase">Location</p>
              <p className="break-words text-base md:text-lg">Bhopal, IN</p>
            </div>
          </a>

          {/* Social Icons */}
          <div className="flex space-x-8 mt-10  text-3xl md:text-4xl">
  
  {/* LinkedIn */}
  <a
    href="https://www.linkedin.com/in/hardik-vishwakarma-3779b6320"
    target="_blank"
    rel="noopener noreferrer"
    className="hover:text-blue-500"
  >
    <FaLinkedin />
  </a>

  {/* Instagram */}
  <a
    href="https://www.instagram.com/hardik_vishwakarma__"
    target="_blank"
    rel="noopener noreferrer"
    className="hover:text-pink-500"
  >
    <FaInstagram />
  </a>

  {/* Facebook */}
  <a
    href="https://www.facebook.com/hardik.vishwakarma.750"
    target="_blank"
    rel="noopener noreferrer"
    className="hover:text-blue-700"
  >
    <FaFacebook />
  </a>

  {/* GitHub */}
  <a
    href="https://github.com/HardikVishwakarma6264"
    target="_blank"
    rel="noopener noreferrer"
    className="hover:text-gray-300"
  >
    <FaGithub />
  </a>

</div>
        </div>
      </div>
    </div>
  );
}
